import { render, staticRenderFns } from "./MessageHistoryCard.vue?vue&type=template&id=67dd4f36&scoped=true"
import script from "./MessageHistoryCard.vue?vue&type=script&lang=ts"
export * from "./MessageHistoryCard.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoryCard.vue?vue&type=style&index=0&id=67dd4f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd4f36",
  null
  
)

export default component.exports